<template>
  <div>
    <div class="nav-container">
      <div class="header">
        <img class="back" src="@/images/back.png" @click="goBack" />
        提现
        <!-- <a class="login" @click="toWithdrawalRecord">提现记录</a> -->
      </div>
    </div>
    <div class="top-margin"></div>
    <div class="contaienr">
      <div class="tip-container">
        <img src="../../images/tip_withdrawal.png" class="tip" />
        <span class="tip-font">提现金额将会按原路返回，到账时间1~3天</span>
      </div>
      <div class="bg-info">
        <span class="t-f16-c1a">提现金额</span>
        <div class="input-view display_flex">
          <span class="unit-input">¥</span>
          <van-field
            class="input-field"
            maxlength="5"
            type="number"
            v-model="moneyValue"
          />
        </div>
        <div class="display_flex m-t-15">
          <span class="t-f14-c99"
            >最大可提现金额<span class="t-f14-c1a m-l-5"
              >{{ freezed }}元，<span
                class="t-f14-c0082ff"
                @click="moneyValue = freezed"
                >全部提现</span
              ></span
            ></span
          >
        </div>
      </div>
    </div>
    <div class="m-20" @click="apiPostWithdraw">
      <van-button type="primary" size="normal" class="main-btn"
        >申请提现</van-button
      >
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import request from "@/api/request";
import { ref } from "vue";
import { Toast } from "vant";
let router;
let moneyValue = ref("");
let freezed = ref("");
export default {
  setup() {
    router = useRouter();
    //查询金额
    getUserInfoBalance();

    return {
      router,
      goBack,
      moneyValue,
      apiPostWithdraw,
      freezed,
      toWithdrawalRecord,
    };
  },
  unmounted() {
    moneyValue.value = "";
  },
};

function apiPostWithdraw() {
  if (parseFloat(moneyValue.value) > parseFloat(freezed.value)) {
    Toast("超出可提现最大金额!");
    return;
  }
  let params = {};

  params["remark"] = "退款";
  params["amount"] = parseFloat(moneyValue.value);
  request.apiPostWithdrawal(params).then(() => {
    Toast("已经提交申请!");
    router.back();
  });
}
function getUserInfoBalance() {
  request.getUserInfo().then((res) => {
    freezed.value = (
      parseFloat(res.data.actual_balance) - parseFloat(res.data.freezed_balance)
    ).toFixed(2);
  });
}
function goBack() {
  router.back();
}
function toWithdrawalRecord() {
  router.push("/user/withdrawal_record");
}
</script>

<style scoped lang="scss">
.t-f14-c99 {
  font-size: 14px;
  color: #999;
}
.bg-info {
  background: #ffffff;
  margin: 10px;
  border-radius: 10px;
  padding: 20px;
}
.tip {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.tip-font {
  font-size: 12px;
  color: #f19321;
  margin-left: 10px;
  font-weight: bold;
}
.tip-container {
  background: #fff9f2 !important;
  line-height: 40px;
  padding: 0px 20px;
}
.t-f14-c0082ff {
  font-size: 14px;
  color: #0082ff;
}
.input-field {
  font-size: 38px;
  color: #1a1a1a;
  font-weight: bold;
}
.unit-input {
  font-size: 38px;
  color: #1a1a1a;
  font-weight: bold;
}
.input-view {
  border-bottom: 1px solid #eeeeee;
  padding: 5px 0;
  align-items: center;
}
.main-container {
  background: #fff;
  border-radius: 5px;
  margin: 20px 10px;
  padding: 20px;
  text-align: left;
}
.unit {
  font-weight: normal;
}
.t-f38-c1a {
  font-size: 38px;
  color: #1a1a1a;
  font-weight: bold;
}
.contaienr {
  // text-align: center;
}
.price {
  margin: 0 auto;
  margin-top: 15%;
}
.nav-container {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
}
.header {
  height: 45px;
  background: #fff;
  border-bottom: 1px solid #eee;
  font-size: 18px;
  color: #333;
  z-index: 999;
  text-align: center;
  line-height: 45px;
  position: relative;
}
.login {
  position: absolute;
  right: 20px;
  top: 2px;
  font-size: 14px;
  color: #005aa0;
}
.back {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
}
</style>